module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA/UlEQVR4nO3Ouw7BYBjGcRKLDuwmFZchZoxicmziMlCHcAlNRCJpFZOIMDhtEhIxGyxMZa6tLF6LpNHwtfmqmnz/4c3zbj+nw+L+E8BkknE6EIzB1JUkSS7lftsIgtiCFylNQC6TKvCdbh2mrmq1cjsajfk4jhuhIrADWLaa3+22U1SEKQCYDlSEaYBnKAhTAc++IbACWs2mEAqH/RTlpuB9tZwv9pv1asKL/SG8qrACFEWRL5fzAeZbFbY0FsReA6YqrIBPMdl0kQAMAa6yDNd4Hq8XLgEQAAEQgJ0BuCIAArAXgGHSEZoOJGBi63Q6Dni+O4OpShPwyywHPACWVjUw9TxO+AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/file/txt.png
// module id = +Gvo
// module chunks = 1